import styled from 'styled-components';
import { NoticeStyle } from './Notice';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledNotice = styled.div<{ $noticeStyle: NoticeStyle }>`
  margin-bottom: ${tvar('space.x4')};
  padding: ${tvar('space.x2')};
  padding-left: calc(2.5rem + ${tvar('space.x4')});
  position: relative;
  min-height: calc(2.5rem + ${tvar('space.x4')});
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${({ $noticeStyle, theme }) =>
    ({
      [NoticeStyle.Success]: theme.colors.validation.success.fillLight,
      [NoticeStyle.Info]: theme.colors.validation.info.fillLight,
      [NoticeStyle.Warning]: theme.colors.validation.warning.fillLight,
      [NoticeStyle.Error]: theme.colors.validation.error.fillLight,
    })[$noticeStyle]};
  border: 1px solid
    ${({ $noticeStyle, theme }) =>
      ({
        [NoticeStyle.Success]: theme.colors.validation.success.border,
        [NoticeStyle.Info]: theme.colors.validation.info.border,
        [NoticeStyle.Warning]: theme.colors.validation.warning.border,
        [NoticeStyle.Error]: theme.colors.validation.error.border,
      })[$noticeStyle]};

  h3 {
    margin-bottom: ${tvar('space.x1')};
  }

  p {
    max-width: 100%;
    line-height: 1.5;
    &:last-child {
      margin-bottom: 0;
    }
  }

  svg {
    position: absolute;
    font-size: 2.5rem;
    top: ${tvar('space.x2')};
    left: ${tvar('space.x2')};
    color: ${({ $noticeStyle, theme }) =>
      ({
        [NoticeStyle.Success]: theme.colors.validation.success.fill,
        [NoticeStyle.Info]: theme.colors.validation.info.fill,
        [NoticeStyle.Warning]: theme.colors.validation.warning.fill,
        [NoticeStyle.Error]: theme.colors.validation.error.fill,
      })[$noticeStyle]};
  }
`;
